var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c(
        "div",
        _vm._b(
          {
            staticClass: "d-flex rounded-xxs",
            class: {
              "bg-danger": _vm.status === "error",
              "bg-success": _vm.status === "success",
              "bg-warning": _vm.status === "warning",
              "align-items-center": _vm.center
            },
            staticStyle: { position: "relative" },
            style: _vm.estilos
          },
          "div",
          _vm.$attrs,
          false
        ),
        [
          _c(
            "div",
            {
              staticClass: "d-flex align-items-center container-icon",
              staticStyle: { width: "100%" }
            },
            [
              _c("span", {
                style: {
                  position: "absolute",
                  left: "0",
                  height: "40px",
                  width: "2px",
                  backgroundColor: _vm.colorIcon
                }
              }),
              _c("icon-svg", {
                class: _vm.status.includes("error_v3") && "icon-error_v3",
                attrs: {
                  name: _vm.iconRecept || _vm.icon,
                  color: _vm.colorIcon,
                  size: _vm.status.includes("warning_v3") ? 40 : 24
                }
              }),
              _c(
                "div",
                {
                  class: _vm.status.includes("v3")
                    ? "mx-5 text-black"
                    : "ml-1/2rem",
                  staticStyle: {
                    width: "100%",
                    "font-size": "0.875rem",
                    color: "#4B4B4BEE"
                  }
                },
                [_vm._t("default")],
                2
              ),
              _c("v-spacer"),
              _vm._t("button"),
              _vm.status.includes("v3")
                ? _c(
                    "button",
                    { on: { click: _vm.removeAlert } },
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: "mdi-close-circle",
                          color: "secondary",
                          size: "24"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }